import * as yup from 'yup';

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address'),
  password: yup
    .string()
    .required('Password is required')
    .min(2, 'Password must be at least 6 characters'),
});

export type LoginFormValues = yup.InferType<typeof loginSchema>;
